import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
} from "@mui/material";
import { Stack } from "@mui/system";
import ChangeReceiptsStatusTable from "./ChangeReceiptsStatusTable";
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

interface Props {
  open: boolean;
  handleClose: () => void;
}

const tableHeadings = {
  company: "Company",
  receipt_number: "Receipt Number",
  receipt_amount: "Receipt Amount",
  fme_status: "Receipt Status",
};
const rows = [
  {
  company: "Boyle",
  receipt_number: "RC259001039",
  receipt_amount: "174.35",
  fme_status: "Approved For Invoice",
  },
   {
  company: "Entain",
  receipt_number: "RC678984",
  receipt_amount: "12345.67",
  fme_status: "Approved For Invoice",
  },
  {
  company: "Entain",
  receipt_number: "RC6784432",
  receipt_amount: "123",
  fme_status: "Approved For Invoice",
  },
];


const ChangeReceiptsStatus = ({
  open,
  handleClose,
}: Props) => {
  return (
    <>
    <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
      >
        <Paper sx={{ padding: "16px 24px 20px 24px" }}>
          <DialogTitle sx={{ padding: "0px 0px 10px 0px" }}>
           Change Receipts Status
          </DialogTitle>

          <ChangeReceiptsStatusTable tableHeadings={tableHeadings} rows={rows} />

          <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
            <Button color="secondary" onClick={handleClose}>
              CANCEL
            </Button>
            <Button sx={{ml:2}} color="secondary" variant="contained" endIcon={<SaveOutlinedIcon />} onClick={handleClose}>
              Save Changes
            </Button>
          </Stack>
        </Paper>
      </Dialog>
    </>
  )
}

export default ChangeReceiptsStatus